export function getById (state) {
	return id => state.competitions.find(competition => competition.id === id);
}
